import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ICenterChainEndOffersResponse, ReportActionCreators } from '@nkr/store/index';
import { ICenterChainEndOffer } from '@nkr/models/index';
import { GridApi, ColumnApi, GridReadyEvent, FirstDataRenderedEvent, RowDataChangedEvent, SortChangedEvent } from 'ag-grid-community';
import { FormControl } from 'react-bootstrap';
import Grid from './grid';

interface IOwnProps {
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterChainEndOffers: (centerId: number) => Promise<ICenterChainEndOffersResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: ICenterChainEndOffer[]
    isAccepted: string
}

class ChainEndOffers extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        isAccepted: ''
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.columnApi.applyColumnState({
            state: [
                {
                    colId: 'offerDateTime',
                    sort: 'desc' // 'asc'
                }
            ]
        });

        e.api.sizeColumnsToFit();
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    }

    onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting chain end offers, one moment please...').then(() => {
            this.props.getCenterChainEndOffers(this.props.centerId).then(response => {
                this.setState({
                    data: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    handleAcceptedChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            isAccepted: e.currentTarget.value
        }, () => {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 1000)
        });
    }

    render = () => {
        const filteredData = this.state.data.filter(x => {
            let isAccepted = this.state.isAccepted != '' ? x.isAccepted == (this.state.isAccepted == 'Yes') : true;
            return isAccepted;
        });

        return (
            <>
                <div className='well well-sm' style={{ display: 'flex', alignItems: 'center', paddingTop: 4.5, paddingBottom: 4.5, marginBottom: 5 }}>
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                        <div style={{ marginRight: 5 }}>Accepted:</div>
                        <div style={{ marginRight: 20 }}>
                            <FormControl
                                componentClass='select'
                                bsSize='sm'
                                value={this.state.isAccepted}
                                onChange={this.handleAcceptedChange}>
                                <option value={''}>Yes or No</option>
                                <option value={'Yes'}>Yes Only</option>
                                <option value={'No'}>No Only</option>
                            </FormControl>
                        </div>
                    </div>
                </div>

                <Grid
                    data={filteredData}
                    onGridReady={this.onGridReady}
                    onFirstDataRendered={this.onFirstDataRendered}
                    onRowDataChanged={this.onRowDataChanged}
                    onSortChanged={this.onSortChanged} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCenterChainEndOffers: (centerId) => {
            return dispatch(ReportActionCreators.getCenterChainEndOffers(centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ChainEndOffers);